module.exports = __webpack_public_path__ + "static/media/104.42773a33.webp";